import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Option = styled.div<{ isSelect: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background-color: ${(props) => (props.isSelect ? "rgba(255, 255, 255, 0.37);" : "rgba(235, 237, 245, 0.37)")};
  border: ${(props) => (props.isSelect ? "1px solid #577EFF;" : "1px solid rgba(255, 255, 255, 0)")};
  cursor: pointer;
`;
